import React      from 'react'
import {
          Form,
          Grid,
          Input,
          Button,
          Icon,
          Popup
       }          from 'semantic-ui-react'
import Utils      from './../../../modules/utils'


class CategoryInput extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state =
    {
      loading : true,
      edit    : false,
      category: this.props.category || null,
      showSubs: false,
      inputs  :
      {
        name :
        {
          value   : "",
          valid   : null,
          required: true,
          message : ""
        },
        subcategories :
        {
          value   : [],
          valid   : true,
          required: true,
          message : ""
        }
      }
    }
  }

  componentDidMount()
  {
    var {category} = this.props
    if (category && category.id)
    {
      this.setInputFromCategory()
    }
    else
    {
      this.setState({loading: false})
    }
  }

  componentDidUpdate()
  {
    if (this.props.category !== this.state.category)
    {
      this.setState({category: this.props.category})
    }
  }

  setInputFromCategory = () =>
  {
    let {category, inputs, showSubs} = this.state
    if (!category) return;

    Object.keys(inputs).forEach((key) =>
    {
      let input = inputs[key]

      switch (key)
      {
        case "name"  :
        {
          input.valid = true
          input.value = category[key]
          break
        }
        case "subcategories"  :
        {
          input.valid = true
          input.value = category[key]
          if (input.value.length > 0) showSubs = true
          break
        }
        default :
        {

        }
      }
    })

    this.setState({inputs, loading: false, showSubs})
  }

  handleChange = (e, data) =>
  {
    let {inputs, category} = this.state
    let input    = inputs[data.name]
    input.value  = data.value

    switch (data.name)
    {
      case "name" :
      {
        input.value   = input.value.toUpperCase()
        let required  = input.required && input.value.length === 0
        let validate  = !required ? this.props.validate(input.value, 'categories') : true
        input.valid   = !required && validate
        input.message = required ? "Value should not be empty" : "Name should be unique"
        break
      }
      case "subcategories" :
      {
        let categoryId = category && category.id
        let data = {subcategories: input.value}
        this.props.handleSubmit({category: data}, categoryId, 'categories')
        break
      }
      default :
      {

      }
    }

    this.setState({inputs})
  }

  handleSubmit = (e) =>
  {
    e.preventDefault()
    let {category, inputs} = this.state
    let {data, valid} = this.getData()
    let categoryId = category && category.id

    var callback = (error, data) =>
    {
      if(error)
      {
        let errors = error.response.data
        let errorMessage = Object.keys(errors).map((key) =>
        {
          return `${key}: ${errors[key].join(', ')}`
        })
        inputs.name.message = errorMessage
        this.setState({inputs})
      }
      else
      {
        if (categoryId)
        {
          this.setState({edit: false})
        }
        else
        {
          inputs.name.value = ""
          inputs.name.valid = null
          this.setState({inputs})
        }
      }
    }

    this.props.handleSubmit({category: data}, categoryId, 'categories', callback)
  }

  handleDestroy = (e) =>
  {
    e.preventDefault()
    var {category} = this.state
    this.props.handleDestroy(category.id, 'categories')
  }

  enableEdit = () =>
  {
    this.setState({edit: true})
  }

  getData = () =>
  {
    let {inputs} = this.state
    let data     = {}
    data.name    = Utils.trim(inputs.name.value)

    return {data, valid: this.isInputsValid()}
  }

  isInputsValid = () =>
  {
    let {inputs} = this.state
    let valid    = Utils.isInputsValidated(inputs)
    return valid
  }

  toggleSubs = () =>
  {
    this.setState({showSubs: true })
  }

  render()
  {
    let {inputs, category, loading, edit, showSubs} = this.state
    let isOld    = category && category.id
    let editable = isOld && !edit
    let isValid  = this.isInputsValid()

    var subcategories = this.props.subcategories ? Utils.objectsToOptionsHash(this.props.subcategories, 'id', 'name') : []

    let markup =
      loading ? null
      :
      <Grid.Row>
        <Grid.Column width={14}>
          <Form.Field
            required
            control={Input}
            placeholder='Category Name'
            name='name'
            readOnly={editable}
            value={inputs.name.value}
            onChange={(e, {value}) => this.handleChange(e, {name: 'name', value: value})}
            error={inputs.name.valid == false ? {
              content: inputs.name.message
            } : false }
          />
          {
            showSubs &&
            <div>
              <div className='nested-line'></div>
              <Icon name="arrow right" className='nested-arrow' />
              <Form.Select
                width={15}
                multiple
                label="Sub-Category"
                className='float-right'
                name='subcategory-select'
                placeholder="Specify Sub-Categories"
                options={subcategories}
                value={inputs.subcategories.value}
                onChange={(e, {value}) => this.handleChange(e, {name: 'subcategories', value: value})}
              />
            </div>
          }
        </Grid.Column>
        {
          isOld ?
          <Grid.Column width={2} style={{display: 'flex', justifyContent: 'space-around', top: '10px'}}>
            {
              this.state.edit ?
              <Icon
                style={{cursor: 'pointer'}}
                name='check'
                color='green'
                disabled={!isValid}
                onClick={this.handleSubmit}
              />
              :
              <Icon
                style={{cursor: 'pointer'}}
                name='pencil'
                onClick={this.enableEdit}
              />
            }
            {
              !showSubs &&
              <Popup
                content="Select Sub-Categories"
                basic
                trigger={<Icon
                          style={{cursor: 'pointer'}}
                          name='sitemap'
                          onClick={this.toggleSubs}
                        />}
              />

            }
            <Icon
              style={{cursor: 'pointer'}}
              name='trash alternate'
              color='red'
              onClick={this.handleDestroy}
            />
          </Grid.Column>
          :
          <Grid.Column width={2}>
            <Button
              primary
              content="Add"
              disabled={!isValid}
              onClick={this.handleSubmit}
            />
          </Grid.Column>
        }
      </Grid.Row>

    return markup;
  }
}

export default CategoryInput
